module.exports = __webpack_public_path__ + "static/media/chilum.a925334e.png";